import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import Playbooks from './pages/Playbooks';
import DemoCenter from './pages/DemoCenter';
import Settings from './pages/Settings';
import PlaceholderPage from './pages/PlaceholderPage';
import './index.css';

function App() {
  return (
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/playbooks" element={<Playbooks />} />
          <Route path="/demo-center" element={<DemoCenter />} />
          <Route path="/tasks" element={<PlaceholderPage title="Success Tasks" />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Layout>
    </HashRouter>
  );
}

export default App;